import React from "react";
import {useLazyQuery } from "@apollo/client";
import {Box, Layer} from "grommet";
import {DataGrid} from "@mui/x-data-grid";
import {QUERY_USER_SERVICES_USED} from "./UserGQL.js";
import moment from "moment/moment.js";

function LayerServicesUsed(props){
    const [servicesUsed,setServicesUsed]=React.useState(null);

    const [ queryServicesUsedList
    ]  = useLazyQuery(QUERY_USER_SERVICES_USED, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            console.log("DATA",data);
            if(data["clubmate_entrance_clubmatereservation"]){
                setServicesUsed(transformData(data));
            }
        },
        onError:(error)=>{
            console.log(error);
        },
        notifyOnNetworkStatusChange: true, // did the work
    });

    React.useEffect(()=>{
        queryServicesUsedList({variables:{userId:props?.id}})
    },[])

    const transformData = (data) => {
        if (!data) return [];
        return data["clubmate_entrance_clubmatereservation"].map((event) => ({
            id: event?.id,
            datetime: moment(event?.datetime).format("DD-MM-YYYY HH:mm:ss"),
            service: event?.clubmateservice_clubmateservice?.name,
        }));
    };

    const columnsServicesUsed = [
        { field: 'datetime', headerName: 'Data e Ora', width: 200 },
        { field: 'service', headerName: 'Servizio', width: 300 },
    ];


    return (
        <Layer onEsc={props?.onEscLayer} onClickOutside={props?.onEscLayer}>
            <Box margin={"medium"} gap={"medium"} overflow="auto"  height="100%" width="800px" alignSelf='center' style={{marginTop:'40px'}}>
                <div style={{ height: '75vh', width: '800px' }}>
                    <DataGrid
                        rows={servicesUsed || []}
                        columns={columnsServicesUsed}
                    />
                </div>
            </Box>
        </Layer>
    )
}

export default LayerServicesUsed;